<template>
  <div
    class="wt2-edit-asset-details wt2-modal-inner"
    :class="{ '-updating': updateStatus.inProgress }"
  >
    <div class="-title wt2-text-l2">
      {{ 'editAssetDetails.title' | culture }}
    </div>
    <div class="-updateError" v-if="this.updateStatus.error">
      {{ 'editAssetDetails.updateError' | culture }}
    </div>
    <div class="wt2-edit-asset-details-inner">
      <div class="-asset-details-thumbnail">
        <div class="-thumbnail">
          <img :src="posterUrl" />
        </div>
        <div class="-date wt2-text-s">{{ publicationDate }}</div>
      </div>
      <div class="-asset-details-edit">
        <div class="-row">
          <wt-text-field
            v-model="editFields.title"
            :mandatory="true"
            :placeholder="'editAssetDetails.titlePlacholder' | culture"
          />
        </div>
        <div class="-row">
          <wt-toggle
            v-model="editFields.shareWithTeam"
            :label-left="'editAssetDetails.shareLabel' | culture"
            :disabled="!isMyUpload"
          />
        </div>
        <div class="-row">
          <wt-add-keywords
            theme="black-theme"
            :keyword-height="31"
            :keywords="editFields.keywords"
            :emptyKeywordsPlaceholder="
              'editAssetDetails.keywordsPlaceholder' | culture
            "
            :hasKeywordsPlaceholder="
              'editAssetDetails.keywordsPlaceholder' | culture
            "
            @addkeyword="addKeyword"
            @removekeyword="removeKeyword"
          ></wt-add-keywords>
        </div>
        <div class="-row -flex">
          <div class="-attributionInput">
            <wt-text-field
              v-model="editFields.attribution"
              :placeholder="'editAssetDetails.creditPlaceholder' | culture"
              :maxlength="100"
            />
          </div>
          <div class="-attributionCheckbox">
            <wt-check-box
              v-model="editFields.attributionMode"
              :disabled="isAttributionEmpty"
              :label-right="'editAssetDetails.displayCredits' | culture"
            />
          </div>
        </div>
        <div class="-actions">
          <wt-button
            class="-smaller-font -min-width-unset"
            type="transparent"
            :text="'generic.CANCEL' | culture"
            @click="closeModal"
          ></wt-button>
          <wt-button
            :text="saveLabel"
            :disabled="updateStatus.inProgress || !isAbleToUpdate"
            @click="update()"
          ></wt-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';

export default {
  data() {
    return {
      isMyUpload:
        parseInt(this.asset.metadata.ownerUserDbId) ===
        app.rootStore.state.user['employeeId'],
      publicationDate: app
        .moment(this.asset.metadata.publicationDate)
        .format('MM/DD/YYYY hh:mma'),
      assetUUID: this.asset.metadata.assetUUID,
      editFields: {
        title: this.asset.metadata.title,
        shareWithTeam: this.asset.metadata.privacy !== 'USER_PRIVATE',
        attribution: this.asset.metadata.attribution,
        attributionMode:
          this.asset.metadata.attributionMode ===
          app.attributionType.SHOW_IN_VIDEO,
        keywords: _.uniq(this.asset.metadata.keywords || []),
      },
      updateStatus: {
        inProgress: false,
        error: false,
      },
    };
  },
  props: {
    closeModal: {
      type: Function,
      required: true,
    },
    asset: {
      type: Object,
      required: true,
    },
  },
  watch: {
    editFields: {
      handler() {
        // reset update error when user changes fields
        this.updateStatus.error = false;
      },
      deep: true,
    },
  },
  computed: {
    posterUrl: function () {
      return (
        this.asset.metadata.thumbnail256x144Url ||
        this.asset.metadata.thumbnail160x90Url ||
        this.asset.thumbnail ||
        null
      );
    },
    updateMetadata: function () {
      return {
        title: this.editFields.title,
        privacy:
          this.asset.metadata.privacy === app.privacyType.PUBLIC
            ? app.privacyType.PUBLIC
            : this.editFields.shareWithTeam
            ? app.privacyType.ORGANIZATION_PRIVATE
            : app.privacyType.USER_PRIVATE,
        attribution: this.editFields.attribution,
        attributionMode:
          this.editFields.attributionMode && !this.isAttributionEmpty
            ? app.attributionType.SHOW_IN_VIDEO
            : app.attributionType.NONE,
        keywords: this.editFields.keywords,
        // although it's readonly on client, BE requires it for finding asset
        contentFamily: this.asset.metadata.contentFamily,
      };
    },
    isAttributionEmpty: function () {
      return this.editFields.attribution
        ? _.isEmpty(this.editFields.attribution.trim())
        : true;
    },
    saveLabel: function () {
      return this.updateStatus.inProgress
        ? app.culture.get('generic.SAVING') + '...'
        : app.culture.get('generic.UPDATE');
    },
    isAbleToUpdate: function () {
      let isValid = true;
      if (_.isEmpty(this.editFields.title.trim())) {
        isValid = false;
      }
      return isValid;
    },
  },
  methods: {
    update: function () {
      this.updateStatus.error = false;

      this.updateStatus.inProgress = true;

      app.api.asset
        .editAsset(this.updateMetadata, {
          assetUUID: this.assetUUID,
          mediaAssetType: this.asset.metadata.assetType,
        })
        .then(
          () => {
            this.closeModal({
              metadata: this.updateMetadata,
              assetUUID: this.assetUUID,
            });
          },
          () => {
            this.updateStatus.inProgress = false;
            this.updateStatus.error = true;
          }
        );
    },
    addKeyword: function (newKeyword) {
      if (newKeyword && newKeyword !== '') {
        this.editFields.keywords = _.uniq(
          this.editFields.keywords.concat(newKeyword)
        );
      }
    },
    removeKeyword: function (removedKeyword) {
      this.editFields.keywords = this.editFields.keywords.filter(
        (keyword) => keyword !== removedKeyword
      );
    },
  },
};
</script>
